import { asyncType } from "redux/types/asyncTypes";

export const FETCH_SOCIAL_ASSETS = asyncType("FETCH_SOCIAL_ASSETS");
export const FETCH_IMAGE_ASSETS = asyncType("FETCH_IMAGE_ASSETS");
export const FETCH_VIDEO_ASSETS = asyncType("FETCH_VIDEO_ASSETS");
export const FETCH_DOC_ASSETS = asyncType("FETCH_DOC_ASSETS");
export const FETCH_SINGLE_ASSET = asyncType("FETCH_SINGLE_ASSET");
